import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  Box, Card, TextField, Button, Typography, Alert,
  InputAdornment, IconButton, Link
} from '@mui/material';
import VisibilityIcon    from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { loginThunk, clearError } from '../../app/slices/authSlice';

export default function LoginPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error } = useSelector(s => s.auth);
  const [form, setForm] = useState({ loginId: '', password: '' });
  const [show, setShow] = useState(false);

  const handle = async e => {
    e.preventDefault();
    dispatch(clearError());
    const res = await dispatch(loginThunk(form));
    if (res.type.endsWith('/fulfilled')) navigate('/dashboard');
  };

  return (
    <Box minHeight="100vh" display="flex" alignItems="center" justifyContent="center"
      sx={{ background: 'linear-gradient(135deg,#ede9fe 0%,#e0e7ff 50%,#f0f9ff 100%)' }}>
      <Box width="100%" maxWidth={420} px={2}>
        {/* Logo */}
        <Box textAlign="center" mb={4}>
          <Box display="inline-flex" alignItems="center" gap={1.5} mb={1}>
            <Box sx={{
              width: 40, height: 40, borderRadius: 2.5,
              background: 'linear-gradient(135deg,#4f46e5,#818cf8)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              boxShadow: '0 4px 16px rgba(79,70,229,0.35)',
            }}>
              <Typography sx={{ color: '#fff', fontWeight: 800, fontSize: '1.1rem', fontFamily: "'Sora',sans-serif" }}>A</Typography>
            </Box>
            <Typography variant="h4" fontWeight={800} fontFamily="'Sora',sans-serif"
              sx={{ color: '#0f172a', letterSpacing: '-1px' }}>
              Align
            </Typography>
          </Box>
          <Typography variant="body2" color="text.secondary">Sign in to your workspace</Typography>
        </Box>

        <Card sx={{ p: 3.5, borderRadius: 3 }}>
          {error && (
            <Alert severity="error" sx={{ mb: 2.5 }} onClose={() => dispatch(clearError())}>{error}</Alert>
          )}
          <Box component="form" onSubmit={handle} display="flex" flexDirection="column" gap={2.5}>
            <TextField
              label="Login ID or Email"
              value={form.loginId}
              onChange={e => setForm(p => ({ ...p, loginId: e.target.value }))}
              fullWidth autoFocus required
            />
            <TextField
              label="Password"
              type={show ? 'text' : 'password'}
              value={form.password}
              onChange={e => setForm(p => ({ ...p, password: e.target.value }))}
              fullWidth required
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShow(p => !p)} size="small">
                      {show ? <VisibilityOffIcon fontSize="small" /> : <VisibilityIcon fontSize="small" />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <Button type="submit" variant="contained" fullWidth size="large" disabled={loading}
              sx={{ mt: 0.5, py: 1.3, fontSize: '0.95rem' }}>
              {loading ? 'Signing in…' : 'Sign In'}
            </Button>
          </Box>
          <Box textAlign="center" mt={2.5}>
            <Link href="/forgot-password" variant="body2" underline="hover" color="primary">
              Forgot password?
            </Link>
          </Box>
        </Card>

        <Alert severity="info" sx={{ mt: 2, borderRadius: 2, fontSize: '0.75rem' }}>
          Default: <strong>admin</strong> / <strong>Admin@123</strong>
        </Alert>
      </Box>
    </Box>
  );
}
